// extracted by mini-css-extract-plugin
export default {"container":"wAiTc","title-section":"NADui","body-section":"cMnlI"};